import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/nutrition-order";

export const pagingNutritionOrder = (searchObject) =>
  axios.post(API_PATH + "/search-by-page", searchObject);

export const getNutritionOrderById = (nutritionOrderId) =>
  axios.get(API_PATH + "/get-by-id/" + nutritionOrderId);

export const saveNutritionOrder = (nutritionOrder) =>
  axios.post(API_PATH + "/save-or-update", nutritionOrder);

export const deleteNutritionOrder = (nutritionOrderId) =>
  axios.delete(API_PATH + "/mark-delete/" + nutritionOrderId);
